// src/lib/transactions/mapping.ts
// Frontend Data Canon mapping functions (CANON v1.3.0 section 4.3)
// SSOT for transaction kind → display type/direction mapping

/**
 * Maps transaction kind to human-readable display type
 * Canon Ref: CANON.md section 4.3 Frontend Data Canon
 */
export function mapKindToDisplayType(kind: string): string {
  const map: Record<string, string> = {
    'drain': 'Liquidation',
    'va_deposit': 'Deposit',
    'payout': 'Withdrawal',
    'transfer': 'Transfer',
    'return': 'Return'
  };
  return map[kind] || kind;
}

/**
 * Maps transaction kind to direction
 * Canon Ref: CANON.md section 4.3 Frontend Data Canon
 */
export function mapKindToDirection(kind: string): 'deposit' | 'withdrawal' | 'transfer' {
  if (kind === 'va_deposit' || kind === 'return') return 'deposit';
  if (kind === 'payout' || kind === 'drain') return 'withdrawal';
  return 'transfer';
}

/**
 * Maps transaction data from DB format to display format
 * Canon Ref: CANON.md section 4.3 Frontend Data Canon
 */
export interface TransactionDisplayData {
  display_type: string;
  display_amount: number;
  display_currency: string;
  direction: 'deposit' | 'withdrawal' | 'transfer';
  occurred_at: string;
}

export function mapTransactionForDisplay(tx: {
  kind: string;
  amount_in: number | null;
  asset_in: string | null;
  amount_out: number | null;
  asset_out: string | null;
  settled_at: string | null;
  created_at: string;
}): TransactionDisplayData {
  return {
    display_type: mapKindToDisplayType(tx.kind),
    display_amount: tx.amount_out || tx.amount_in || 0,
    display_currency: tx.asset_out || tx.asset_in || 'USD',
    direction: mapKindToDirection(tx.kind),
    occurred_at: tx.settled_at || tx.created_at
  };
}

